import React, { useState } from "react";
import "../styles/accordion.css";

const Accordion = ({ sections }) => {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleSection = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <div className="accordion">
      {sections.map((section, index) => (
        <div key={index} className="accordion-section">
          <button
            onClick={() => toggleSection(index)}
            className={`accordion-button ${
              activeIndex === index ? "active" : ""
            }`}
          >
            {section.title}
            <span className="accordion-icon">
              {activeIndex === index ? "−" : "+"}
            </span>
          </button>
          {activeIndex === index && (
            <div className="accordion-content">
              {section.blockquote && (
                <blockquote className="accordion-blockquote">
                  {section.blockquote}
                  {section.blockquoteAuthor && (
                    <cite className="accordion-blockquote-author">
                      — {section.blockquoteAuthor}
                    </cite>
                  )}
                </blockquote>
              )}
              <p>{section.content}</p>
              {section.image && <img src={section.image} alt={section.title} />}
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default Accordion;
